import { createContext } from "react";

export interface AppReadyState {
  isReady: boolean;
  authInitialized: boolean;
  permissionsLoaded: boolean;
  error: string | null;
}

export interface AppReadyContextType extends AppReadyState {
  refresh: () => void;
}

export const AppReadyContext = createContext<AppReadyContextType | null>(null);
